import apiClient from './apiClient';
import {
  ImageQualityCheckResponse,
  ImageReportAnalyzeResponse,
  ImageReportDetail,
  ImageReportStructured,
  ImageReportSummary,
} from '../types';

export interface AttachImageMetadataPayload {
  report_id: string;
  metadata?: Record<string, unknown>;
  linked_visit_id?: string | null;
  summary_md?: string | null;
  structured_report?: ImageReportStructured | null;
}

export async function fetchImageReport(reportId: string): Promise<ImageReportDetail> {
  const response = await apiClient.get<ImageReportDetail>(`/image-reports/${reportId}`);
  return response.data;
}

export async function fetchImageReports(params?: { limit?: number; offset?: number }): Promise<ImageReportSummary[]> {
  const response = await apiClient.get<ImageReportSummary[]>('/image-reports', { params });
  return response.data;
}

export async function evaluateImageQuality(file: File, focus: string): Promise<ImageQualityCheckResponse> {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('focus', focus);
  const response = await apiClient.post<ImageQualityCheckResponse>('/image-reports/quality', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
}

export async function analyzeImageReport(formData: FormData): Promise<ImageReportAnalyzeResponse> {
  const response = await apiClient.post<ImageReportAnalyzeResponse>('/image-reports/analyze', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
}

export async function attachImageReportMetadata(payload: AttachImageMetadataPayload): Promise<ImageReportDetail> {
  const response = await apiClient.post<ImageReportDetail>('/image-reports/attach-metadata', payload);
  return response.data;
}
